// src/index.js
import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./index.css";
import App from "./App.jsx";

// NOTE:
// - We no longer touch AUTH_TOKEN here.
// - api/client.js will bootstrap auth header from storage/env on load.
// - Globally silence console logging in production builds to keep browser console clean
if (process.env.NODE_ENV === "production" && typeof window !== "undefined") {
  /* eslint-disable no-console */
  console.log = () => {};
  console.debug = () => {};
  /* eslint-enable no-console */
}

const container = document.getElementById("root");
const app = (
  <HelmetProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </HelmetProvider>
);

if (container) {
  const hasPrerenderedMarkup = container.hasChildNodes();
  if (hasPrerenderedMarkup && typeof hydrateRoot === "function") {
    hydrateRoot(container, app);
  } else {
    createRoot(container).render(app);
  }
}
